export default "__VITE_ASSET__CWfBQ6HU__"